import React from 'react'
import PropTypes from 'prop-types'
import { lightBlue500 } from 'material-ui/styles/colors'
import FormSelect from 'components/forms/bases/FormSelect'

const Dropdown = ({
  style,
  underlineStyle,
  iconStyle,
  labelStyle,
  ...props
}) => (
  <FormSelect
    {...props}
    style={{
      border: '1px solid #e5e5e5',
      borderRadius: '3px',
      width: 'auto',
      ...style,
    }}
    underlineStyle={{
      display: 'none',
      ...underlineStyle,
    }}
    iconStyle={{
      fill: lightBlue500,
      ...iconStyle,
    }}
    labelStyle={{
      textAlign: 'center',
      minWidth: 120,
      paddingRight: 30,
      ...labelStyle,
    }}
  />
)

Dropdown.propTypes = {
  ...FormSelect.propTypes,
}
Dropdown.defaultProps = {
  ...FormSelect.defaultProps,
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/materialUI/Dropdown.js